import ShopEvent from './shopEvent';
import CartCache from '../../cart/api/cache';

const event = new ShopEvent(
  'cart_complete',
  process.env.GATSBY_SHOPEVENT_COOKIE_DOMAIN,
);

const cartCache = new CartCache();

async function handleCartComplete(onFired) {
  await event.handle(async () => {
    await cartCache.clear();
    onFired();
  });
}

// eslint-disable-next-line import/prefer-default-export
export { handleCartComplete };
